export const variables = [
  {
    full_name: 'bacon',
    id: 1,
    type: 'food',
    units: 'C',
  },
  {
    full_name: 'egg',
    id: 2,
    type: 'food',
    units: 'C',
  },
  {
    full_name: 'chicken',
    id: 3,
    type: 'meat',
    units: 'C',
  },
  {
    full_name: 'salad',
    id: 4,
    type: 'vegetable',
    units: 'C',
  },
  {
    full_name: 'shrimp',
    id: 5,
    type: 'food',
    units: 'C',
  },
  {
    full_name: 'pizza',
    id: 6,
    type: 'food',
    units: 'hr',
  },
  {
    full_name: 'seafood',
    id: 7,
    type: 'food',
    units: 'hr',
  },
  {
    full_name: 'rice',
    id: 8,
    type: 'food',
    units: 'hr',
  },
  {
    full_name: 'milk',
    id: 9,
    type: 'food',
    units: 'hr',
  },
  {
    full_name: 'bread',
    id: 10,
    type: 'food',
    units: 'hr',
  },
];

export const variablesLineChart = [
  {
    full_name: 'bacon',
    id: 1,
    type: 'food',
    units: 'C',
  },
  {
    full_name: 'egg',
    id: 2,
    type: 'food',
    units: 'C',
  },
];

export const pieChart = {
  chart_data: '',
  chart_name: 'tony pie',
  created_at: '2020-09-18T15:27:19.000000Z',
  id: 9,
  options: { variables: [] },
  type: 'pie',
  updated_at: '2020-09-18T15:27:19.000000Z',
};

export const lineChart = {
  chart_data: '',
  chart_name: 'truong-line-chart',
  created_at: '2020-09-18T15:27:19.000000Z',
  id: 17,
  options: { meters: [] },
  type: 'line',
  updated_at: '2020-09-18T15:27:19.000000Z',
};

export const dataVariableLineChart = [
  [
    {
      output_variable_id: 1,
      value: '19.44941729678375',
      datetime: '2001-01-21 07:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '20.30068910969253',
      datetime: '2001-01-21 08:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '20.827681333061759',
      datetime: '2001-01-21 09:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '20.999560849340594',
      datetime: '2001-01-21 10:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '21.00013769940796',
      datetime: '2001-01-21 11:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '20.999620484076187',
      datetime: '2001-01-21 12:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '21.000176244388933',
      datetime: '2001-01-21 13:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '21.000218157428124',
      datetime: '2001-01-21 14:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '21.000421765106869',
      datetime: '2001-01-21 15:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '20.99864939487613',
      datetime: '2001-01-21 16:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '21.000133922759678',
      datetime: '2001-01-21 17:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '19.268439646069859',
      datetime: '2001-01-21 18:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '18.195263882946504',
      datetime: '2001-01-21 19:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '18.21192365627272',
      datetime: '2001-01-21 20:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '17.77488567702653',
      datetime: '2001-01-21 21:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '13.060835976002105',
      datetime: '2001-01-21 22:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '12.666215756722642',
      datetime: '2001-01-21 23:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '32.22502513903483',
      datetime: '2001-07-21 00:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '31.964611902128003',
      datetime: '2001-07-21 01:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '32.67788746832393',
      datetime: '2001-07-21 02:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '32.55643367317245',
      datetime: '2001-07-21 03:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '32.331636171681747',
      datetime: '2001-07-21 04:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '31.91148861175564',
      datetime: '2001-07-21 05:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '27.057371167544429',
      datetime: '2001-07-21 06:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 1,
      value: '25.704238989443565',
      datetime: '2001-07-21 07:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
  ],
  [
    {
      output_variable_id: 2,
      value: '20.99864004068997',
      datetime: '2001-01-21 07:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.000565415171775',
      datetime: '2001-01-21 08:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.001365789502758',
      datetime: '2001-01-21 09:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.00135572910053',
      datetime: '2001-01-21 10:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.000911790089817',
      datetime: '2001-01-21 11:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '20.999117555532697',
      datetime: '2001-01-21 12:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '20.99963932824223',
      datetime: '2001-01-21 13:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.000635303666134',
      datetime: '2001-01-21 14:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.00107010361928',
      datetime: '2001-01-21 15:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '20.998636777422278',
      datetime: '2001-01-21 16:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '21.000061189601458',
      datetime: '2001-01-21 17:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '20.259133313203696',
      datetime: '2001-01-21 18:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '19.643502553058246',
      datetime: '2001-01-21 19:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '20.074551512115414',
      datetime: '2001-01-21 20:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '19.600764090114873',
      datetime: '2001-01-21 21:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '13.444298481991629',
      datetime: '2001-01-21 22:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '12.725885435500184',
      datetime: '2001-01-21 23:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '31.495816580788924',
      datetime: '2001-07-21 00:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '31.24232917386063',
      datetime: '2001-07-21 01:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '32.59385456826287',
      datetime: '2001-07-21 02:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '32.56061619088159',
      datetime: '2001-07-21 03:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '32.338289444007049',
      datetime: '2001-07-21 04:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '32.314587646911558',
      datetime: '2001-07-21 05:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '27.353991312177059',
      datetime: '2001-07-21 06:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
    {
      output_variable_id: 2,
      value: '26.80961681158423',
      datetime: '2001-07-21 07:00:00',
      min_datetime: null,
      min_value: null,
      max_datetime: null,
      max_value: null,
    },
  ],
];

export const violinPlot = {
  chart_name: 'habit_rate',
  id: 17,
  type: 'violinPlot',
  metrics: [
    {
      name: 'sum_retention',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0.9904761904761905,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.1577940586939371,
          confidentialInternal: {
            changes: 0.009615384615384581,
            lowerBound: -0.0037561241980701766,
            upperBound: 0.022986893428839337,
          },
          mean: 1,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.1577940586939371,
          confidentialInternal: {
            changes: 0.009615384615384581,
            lowerBound: -0.0037561241980701766,
            upperBound: 0.022986893428839337,
          },
          mean: 1,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'aha_rate',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0.4380952380952381,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.35214948343593666,
          confidentialInternal: {
            changes: 0.10125858123569795,
            lowerBound: -0.11204449482874583,
            upperBound: 0.31456165730014174,
          },
          mean: 0.4824561403508772,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.23904817295524872,
          confidentialInternal: {
            changes: 0.13053732567678425,
            lowerBound: -0.08676787850009769,
            upperBound: 0.3478425298536662,
          },
          mean: 0.49528301886792453,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'trial_rate',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: null,
          confidentialInternal: {
            changes: null,
            lowerBound: null,
            upperBound: null,
          },
          mean: 0,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
        {
          PValue: null,
          confidentialInternal: {
            changes: null,
            lowerBound: null,
            upperBound: null,
          },
          mean: 0,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'habit_rate',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0.3047619047619048,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.8839888991029957,
          confidentialInternal: {
            changes: 0.021521226415094203,
            lowerBound: -0.2675578844956617,
            upperBound: 0.31060033732585013,
          },
          mean: 0.3113207547169811,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.08752419443438687,
          confidentialInternal: {
            changes: -0.23725328947368426,
            lowerBound: -0.50940980298245,
            upperBound: 0.03490322403508138,
          },
          mean: 0.2324561403508772,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'pay_rate',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: null,
          confidentialInternal: {
            changes: null,
            lowerBound: null,
            upperBound: null,
          },
          mean: 0,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
        {
          PValue: null,
          confidentialInternal: {
            changes: null,
            lowerBound: null,
            upperBound: null,
          },
          mean: 0,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'subs_user',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: null,
          confidentialInternal: {
            changes: null,
            lowerBound: null,
            upperBound: null,
          },
          mean: 0,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
        {
          PValue: null,
          confidentialInternal: {
            changes: null,
            lowerBound: null,
            upperBound: null,
          },
          mean: 0,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'retention',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0.9904761904761905,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.1396883190901933,
          confidentialInternal: {
            changes: 0.009615384615384581,
            lowerBound: -0.003144541719445477,
            upperBound: 0.02237531095021464,
          },
          mean: 1,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.1543564334854344,
          confidentialInternal: {
            changes: 0.009615384615384581,
            lowerBound: -0.003616140043634048,
            upperBound: 0.022846909274403207,
          },
          mean: 1,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'count_song_start',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 4.233333333333333,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.16319442532281694,
          confidentialInternal: {
            changes: 0.26021393552221056,
            lowerBound: -0.10601185441247413,
            upperBound: 0.6264397254568953,
          },
          mean: 5.334905660377358,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.39515827793401115,
          confidentialInternal: {
            changes: 0.15416493990882724,
            lowerBound: -0.20188307549057413,
            upperBound: 0.5102129553082286,
          },
          mean: 4.885964912280702,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'setup_rate',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0.4523809523809524,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.6347648067494397,
          confidentialInternal: {
            changes: -0.04986149584487534,
            lowerBound: -0.2555885233049514,
            upperBound: 0.1558655316152007,
          },
          mean: 0.4298245614035088,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.32742665960140827,
          confidentialInternal: {
            changes: 0.10526315789473684,
            lowerBound: -0.10540754424326987,
            upperBound: 0.3159338600327436,
          },
          mean: 0.5,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
      ],
    },
    {
      name: 'aha_rate_2MEd0',
      variants: [
        {
          PValue: null,
          confidentialInternal: null,
          mean: 0.7761904761904762,
          name: 'Ab_num_me_start1',
          variantType: 'BASE',
        },
        {
          PValue: 0.5198813889256748,
          confidentialInternal: {
            changes: -0.03374233128834358,
            lowerBound: -0.13650977606015463,
            upperBound: 0.06902511348346746,
          },
          mean: 0.75,
          name: 'Ab_num_me_start3',
          variantType: 'COMPARED',
        },
        {
          PValue: 0.7739559217864427,
          confidentialInternal: {
            changes: 0.014874406760041637,
            lowerBound: -0.08663279637117294,
            upperBound: 0.1163816098912562,
          },
          mean: 0.7877358490566038,
          name: 'Ab_num_me_start2',
          variantType: 'COMPARED',
        },
      ],
    },
  ],
};
